/*
===============================================================================================================
                                 Copyright 2023-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import * as Sentry from '@sentry/nextjs';

/**
 * Sends a non-error event to Sentry dashboard
 *
 * @param {Object} options configuration options object
 * @param {string} options.eventName name of the logged event, will appear as a tag value in Sentry dashboard
 * @param {string} options.message message text
 * @param {string} options.level log level, e.g 'info', 'warning', 'error'
 *
 */
const logEvent = ({ eventName, message, level = 'info' } = {}) => {
  Sentry.withScope((scope) => {
    scope.setTag('admin-portal-dashboard-event', eventName);
    scope.setLevel(level);
    Sentry.captureMessage(message);
  });
};

/**
 * Sends an exception event to Sentry dashboard
 *
 * @param {Object} options configuration options object
 * @param {string} options.eventName name of the logged event, will appear as a tag value in Sentry dashboard
 * @param {Error} options.exception exception object
 *
 */
const logException = ({ eventName, exception } = {}) => {
  Sentry.withScope((scope) => {
    scope.setTag('admin-portal-dashboard-event', eventName);
    scope.setLevel('error');
    Sentry.captureException(exception);
  });
};

export default {
  logEvent,
  logException,
  flush: Sentry.flush,
  isEnabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED?.toLowerCase() === 'true',
};
